import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userSlice from "../redux/UserSlice";
import cartSlice from "../redux/CartSlice";
import wishlistSlice from "../redux/WishlistSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

import {
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import ProductSlice from "../redux/ProductSlice";

const rootReducer = combineReducers({
  user: userSlice,
  cart: cartSlice,
  wishlist: wishlistSlice,
  product: ProductSlice,
});

const persistConfig = {
  key: "root",
  storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
